import Dialog from '../../../../../dialog/Dialog';
import ChipMedia from '../../../../../chip/ChipMedia';
import ReadOnlyTextEditor from '../../../../../TextEditor/ReadOnlyTextEditor';

const DialogElementLevels = ({ onClose, open, formData, element }) => {
  return (
    <>
      <Dialog
        id={`dialog-element-levels-${element}`}
        show={open}
        title={`View ${element.replace(/-/g, ' ')}`}
        onCloseHeader={true}
        maxWidth={'md'}
        onClose={onClose}
      >
        <div className='flex flex-col gap-4'>
          <ReadOnlyTextEditor content={formData.comment} placeholder='Start entering your text' />
          {formData.media && formData.media.length > 0 && (
            <div className='flex flex-wrap gap-4 items-center'>
              {formData.media.map((data, index) => {
                return (
                  <ChipMedia key={`media-${index}-${data._id}-${data.type}`} index={index} data={data} />
                );
              })}
            </div>
          )}
        </div>
      </Dialog>
    </>
  );
};

export default DialogElementLevels;
